<template>
  <div class="admin">
    <el-card class="my_card2" shadow="never">
      <h3><span>管理员管理</span> <span>可增删查子管理员信息</span></h3>
      <div class="inpsec">
        <el-input
          placeholder="请输入内容"
          suffix-icon="el-icon-search"
          v-model="input2"
        >
        </el-input>
        <el-button
          @click="$router.push('/systemSetup/addAdmin')"
          type="primary"
          icon="el-icon-edit-outline"
          round
          >新增管理员</el-button
        >
      </div>
      <!-- 表格 -->
      <el-table
        :header-cell-style="{ background: '#F5F5F5', color: '#333333' }"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column prop="d1" label="姓名" width="100"> </el-table-column>
        <el-table-column prop="d2" label="手机号"> </el-table-column>
        <el-table-column prop="d3" label="邮箱"> </el-table-column>
        <el-table-column prop="d4" label="所在管理组"> </el-table-column>
        <el-table-column prop="d5" label="账号状态">
          <template slot-scope="scope">
            <el-tag :class="{ jy: scope.row.d5 == '禁用' }">{{
              scope.row.d5
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="d6" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="dialogFormVisible = true"
              size="small"
              >更换管理组</el-button
            >
            <el-button @click="ban(scope.row.d5)" type="text" size="small">{{
              scope.row.d5 == "正常" ? "禁用" : "解禁"
            }}</el-button>
            <el-button type="text" size="small"  @click="$router.push({path:'/systemSetup/addAdmin',query:{type:'edit'}})">编辑</el-button>
            <el-button type="text" size="small" @click="remove">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        class="my-page"
        background
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="prev,pager,next,sizes,jumper"
        :total="70"
      >
      </el-pagination>
    </el-card>
    <!-- 弹框 -->
    <el-dialog title="权限设置" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item
          v-model="form.name"
          label="设置管理组："
          :label-width="formLabelWidth"
        >
          <el-select placeholder="请选择角色" value="超级管理员">
            <el-option label="超级管理员" value="shanghai"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button round @click="dialogFormVisible = false">取 消</el-button>
        <el-button round type="primary" @click="dialogFormVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //表格数据
      form: {
        name: "超级管理员",
      },
      //弹框显示
      dialogFormVisible: false,
      //搜索数据
      input2: "",
      //表格数据
      tableData: [
        {
          d1: "Joel",
          d2: "16346264611",
          d3: "14253254@qq.com",
          d4: "产品部",
          d5: "正常",
          d6: "",
        },
        {
          d1: "Joel",
          d2: "16346264611",
          d3: "14253254@qq.com",
          d4: "产品部",
          d5: "禁用",
          d6: "",
        },
        {
          d1: "Joel",
          d2: "16346264611",
          d3: "14253254@qq.com",
          d4: "产品部",
          d5: "正常",
          d6: "",
        },
        {
          d1: "Joel",
          d2: "16346264611",
          d3: "14253254@qq.com",
          d4: "产品部",
          d5: "正常",
          d6: "",
        },
        {
          d1: "Joel",
          d2: "16346264611",
          d3: "14253254@qq.com",
          d4: "产品部",
          d5: "正常",
          d6: "",
        },
        {
          d1: "Joel",
          d2: "16346264611",
          d3: "14253254@qq.com",
          d4: "产品部",
          d5: "正常",
          d6: "",
        },
        {
          d1: "Joel",
          d2: "16346264611",
          d3: "14253254@qq.com",
          d4: "产品部",
          d5: "正常",
          d6: "",
        },
        {
          d1: "Joel",
          d2: "16346264611",
          d3: "14253254@qq.com",
          d4: "产品部",
          d5: "正常",
          d6: "",
        },
      ],
      formLabelWidth: "120px",
    };
  },
  methods: {
    //点击表格删除
        remove(){
        this.$confirm('是否确定删除', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          roundButton:true,
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
    },
    //点击禁用
    ban(val) {
      let text = "";
      if (val == "正常") {
        text = "禁用";
      } else {
        text = "解禁";
      }
      this.$confirm(`是否确认${text}`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$message({
          type: "success",
          message: `${text}成功!` ,
        });
      });
    },
    //表格里的按钮点击事件
    handleClick() {},
  },
};
</script>

<style lang='less'  >
.admin {
  .my_card2 {
    h3 {
      span {
        &:nth-child(1) {
          font-size: 16px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #33393f;
        }
        &:nth-child(2) {
          margin-left: 12px;
          font-size: 12px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #777777;
        }
      }
    }
    .inpsec {
      margin-top: 26px;
      display: flex;
      justify-content: space-between;
      .el-input--mini .el-input__icon {
        line-height: 36px;
      }

      .el-input,
      .el-input__inner {
        width: 226px;
        height: 36px;
        line-height: 36px;
        border-radius: 18px;
        overflow: hidden;
        background: #f6f6f9;
      }
    }
    //表格样式
    .el-table {
      margin-top: 20px;
      .el-table__header tr,
      .el-table__header th {
        padding: 0;
        height: 43px;
      }
      border: none;
      .cell {
        text-align: center;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }
      .el-table__row {
        height: 52px;
      }
      .el-button {
        font-size: 12px;
      }
      .el-tag {
        width: 74px;
        height: 24px;
        line-height: 22px;
        border-radius: 12px;
        color: #3373fe;
        background: #e2edff;
        font-size: 12px;
      }
      .jy {
        background: rgba(224, 32, 32, 0.10000000149011612);
        color: #ff4343;
      }
    }
    //分页样式
    .my-page {
      margin-top: 15px;
      .el-pager li {
        background-color: #fff;
      }
      .btn-prev {
        background-color: #fff;
      }
      .btn-next {
        background-color: #fff;
      }
      .el-pagination__jump {
        margin-left: 10px;
      }
    }
  }
  //弹框
  .el-dialog {
    width: 586px !important;
    .el-form {
      margin-top: 20px;
      margin-left: 1px;
      height: 150px;

      .el-input {
        width: 423px;
        height: 36px;
        border-radius: 18px;
        overflow: hidden;
      }
      .el-input__inner {
        width: 423px;
        height: 36px;
        border-radius: 18px;
        overflow: hidden;
        background: #f6f6f6;
      }
    }
    .el-form-item__label {
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 37px;
    }
    .el-dialog__footer {
      border-top: 1px solid rgba(0, 0, 0, 0.09);
    }
  }
}
</style>